import { render } from "./WVerticalDivider.vue?vue&type=template&id=b07b8d62"
import script from "./WVerticalDivider.vue?vue&type=script&lang=js"
export * from "./WVerticalDivider.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__